import React from "react";
import { connect } from "react-redux";
import { ReactComponent as NoMessage } from "../../resources/images/noMessage.svg";


const Message = ({ author, content, sameAuthor, messageCreatedByMe }) => {
  const alignClass = messageCreatedByMe
    ? "message_align_right"
    : "message_align_left";

  const authorText = messageCreatedByMe ? "You" : author;

  const contentAdditionalStyles = messageCreatedByMe
    ? "message_right_styles"
    : "message_left_styles";

  return (
    <div className={`message_container ${alignClass}`}>
      <p className={`message_content ${contentAdditionalStyles}`}>{content}</p>
      {!sameAuthor && <p className="message_title">{authorText}</p>}
    </div>
  );
};

const Messages = ({ messages }) => {
  return (
    <div className="messages_container">
      {messages.length < 1 ? 
      <div style={{margin: "10% auto 50% auto", textAlign: 'center'}}>
        <NoMessage />
        <p style={{color: '#070808', fontSize: "14px", fontWeight: "600", lineHeight: "18px"}}>No messages yet</p>
        <p style={{color: '#9ba2a6', fontSize: "12px", fontWeight: "400", lineHeight: "16px"}}>You can send a message by typing in the text area below</p>
      </div>
      :
      messages.map((message, index) => {
        const sameAuthor =
          index > 0 && message.identity === messages[index - 1].identity;

        return (
          <Message
            key={`${message.content}${index}`}
            author={message.identity}
            content={message.content}
            sameAuthor={sameAuthor}
            messageCreatedByMe={message.messageCreatedByMe}
          />
        );
      })}
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStoreStateToProps)(Messages);
